import { Box, Grid, GridItem, Heading } from '@chakra-ui/react';

import ImageShimmer from '../ImageShimmer/ImageShimmer';
import { Text } from '@terminal/design-system';

export default function PostHero({
  imageUrl,
  altText,
  category,
  postDate,
  postTitle,
  postAuthor,
}: {
  imageUrl: string;
  altText: string;
  category: string;
  postDate: string;
  postTitle: string;
  postAuthor: string;
}) {
  const formatDate_withLongMonth = (date: string) => {
    return new Date(date).toLocaleDateString('en-ca', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatDate_forAccessibilty = (date: string) => {
    return new Date(date).toLocaleDateString('en-ca', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
  };

  return (
    <Grid
      templateColumns={{
        base: '1fr',
        lg: '6fr 4fr',
        xl: '41.875rem 1fr',
      }}
      gap={{ base: '0rem', lg: '1.7937rem' }}
    >
      <GridItem>
        <Box
          as="figure"
          w="100%"
          h={{
            base: '15.5rem',
            sm: '18.5rem',
            md: '25.5rem',
            lg: '20rem',
            xl: '24.125rem',
          }}
          mb={{ base: '2rem', lg: '0' }}
          position="relative"
        >
          <ImageShimmer src={imageUrl} alt={altText} style={{ objectFit: 'cover' }} fill priority />
        </Box>
      </GridItem>
      <GridItem position="relative">
        <Box pl={{ lg: '2rem' }}>
          <Text
            variant="hint"
            color="text.secondary"
            textTransform="uppercase"
            letterSpacing="0.0625rem"
            mt={{ lg: '1rem' }}
          >
            {category}
          </Text>

          <Heading
            as="h1"
            fontFamily="heading"
            mt={{ base: '1.2rem', xl: '1.5rem' }}
            color="#2D445D"
            _groupHover={{ textDecoration: 'underline' }}
          >
            {postTitle}
          </Heading>
          <Box mt={{ base: '1.5rem', lg: '2.5rem' }} mb={{ base: 2, lg: 4 }}>
            <Text
              variant="caption"
              color="text.secondary"
              as="time"
              dateTime={formatDate_forAccessibilty(postDate)}
            >
              {formatDate_withLongMonth(postDate)}
            </Text>
            <Text variant="caption" fontWeight="bold" color="text.secondary">
              {postAuthor}
            </Text>
          </Box>
        </Box>

        <Box
          w="100%"
          height={{ base: '0.0625rem' }}
          m={{ base: '1.5rem 0', lg: '0' }}
          bgColor="#D8D8D8"
          position={{ lg: 'absolute' }}
          left={{ lg: '0' }}
          bottom={{ lg: '0' }}
        />
      </GridItem>
    </Grid>
  );
}
